import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH SECTION TO EDIT ********************
export const fetchSectionsGroup = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SECTIONS_GROUP_LOADING,
			payload: true
		});

		const response = await services.get(`/section/group/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SECTIONS_GROUP_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_SECTIONS_GROUP_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
